import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import axios, { isAxiosError } from 'axios'

import type { Address, Pagination, SearchResponse } from '@/types/retail'

const client = axios.create({
  baseURL: import.meta.env.VITE_OATBIZ_API_HOST
})

export const useRetailStore = defineStore('retail', () => {

  const response = ref<SearchResponse>()

  const addresses = computed<Address[] | undefined>(() => response.value?.addresses)
  const pagination = computed<Pagination | undefined>(() => response.value?.pagination)

  const search = async (query: string, page: number, name: string = '') => {
    try {
      const { data } = await client.get<SearchResponse>('/api/retail-stores/search', { params: { q: query, page, name } })
      const { addresses, pagination } = data
      if (addresses && response.value?.addresses) {
        response.value = {
          addresses: response.value.addresses.concat(addresses),
          pagination
        }
      } else if (addresses) {
        response.value = data
      }
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        response.value = error.response.data as SearchResponse
      }
    }
  }

  const reset = () => (response.value = undefined)
  return {
    response,
    addresses,
    pagination,
    search,
    reset
  }
})
